import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'sushiweb/Icons';
import {
  defaultOrgKey,
  ORG_ID_PARAM,
  orgIdKey,
  orgIdMapKey,
  orgValKey,
} from './utils';
import { userModel } from '../../../api';
import SelectV1 from '../../serverDrivenUIComponents/SelectV1';

const dispatchOrgIdChangeEvent = (orgId, orgName) => {
  const event = new CustomEvent('orgIdChange', {
    detail: { orgId, orgName },
  });
  window.dispatchEvent(event);
};

const setOrgIdParam = (orgId) => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set(ORG_ID_PARAM, orgId);
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.pushState({ path: newUrl }, '', newUrl);
};

export const OrgIdDropdownV1 = () => {
  const [orgIdDetails, setOrgIdDetails] = useState([]);
  const [orgIdValueMap, setOrgIdValueMap] = useState({});

  const urlParams = new URLSearchParams(window.location.search);
  const orgIdFromUrl = urlParams.get(ORG_ID_PARAM);

  useEffect(() => {
    userModel.userGetRoleInfo({}).then((response) => {
      if (!response || response?.isError) return null;
      setOrgIdDetails({
        org_list: response?.allowed_orgs,
        default_org: response?.default_org,
      });
      sessionStorage.setItem(
        defaultOrgKey,
        JSON.stringify(response?.default_org),
      );

      if (!sessionStorage.getItem(orgIdKey)) {
        sessionStorage.setItem(orgIdKey, response?.default_org?.id);
        sessionStorage.setItem(orgValKey, response?.default_org?.name);
      }
    });
  }, []);

  useEffect(() => {
    const org_list = orgIdDetails?.org_list;
    const orgIdMap = {};

    if (!org_list || !org_list.length) return;

    for (let i = 0; i < org_list.length; i++) {
      orgIdMap[org_list[i].id] = org_list[i].name;
    }
    setOrgIdValueMap(orgIdMap);
    sessionStorage.setItem(orgIdMapKey, JSON.stringify(orgIdMap));
  }, [orgIdDetails]);

  useEffect(() => {
    if (orgIdFromUrl) {
      sessionStorage.setItem(orgIdKey, orgIdFromUrl);
      sessionStorage.setItem(orgValKey, orgIdValueMap[orgIdFromUrl]);
      dispatchOrgIdChangeEvent(orgIdFromUrl, orgIdValueMap[orgIdFromUrl]);
    } else {
      // set the org_id url param from session storage if not present in url
      const orgId = sessionStorage.getItem(orgIdKey)
        ? sessionStorage.getItem(orgIdKey)
        : orgIdDetails?.default_org?.id;
      const orgName = sessionStorage.getItem(orgValKey)
        ? sessionStorage.getItem(orgValKey)
        : orgIdDetails?.default_org?.name;
      if (orgId) {
        setOrgIdParam(orgId);
        dispatchOrgIdChangeEvent(orgId, orgName);
      }
    }
  }, [orgIdFromUrl, orgIdValueMap]);

  if (!orgIdDetails?.org_list?.length) return null;

  return (
    <div className='tw-w-full tw-h-full'>
      <SelectV1
        selectOptions={orgIdDetails.org_list}
        defaultValue={
          sessionStorage.getItem(orgValKey) ||
          orgIdDetails?.default_org?.name ||
          ''
        }
        disabled={false}
        inputKey={orgIdKey}
        saveOptions={(_, value) => {
          if (sessionStorage.getItem(orgIdKey) == value) return;
          sessionStorage.setItem(orgIdKey, value);
          sessionStorage.setItem(orgValKey, orgIdValueMap[value]);
          dispatchOrgIdChangeEvent(value, orgIdValueMap[value]);
          setOrgIdParam(value);
          window.location.reload();
        }}
        isMultiSelect={false}
        UparrowIcon={<ChevronUp />}
        DownarrowIcon={<ChevronDown />}
        className='!tw-border-white tw-px-5 tw-py-2 tw-h-full'
        top='!tw-top-[50px]'
      />
    </div>
  );
};
